// This file is generated, do not edit!
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import { type Prompt, PromptDaten } from "../../api";
import { useGetApi } from "../client";
import { useCallback } from "react";

export function useUpdatePrompt(): (
  promptId: string,
  requestBody: PromptDaten
) => Promise<Prompt> {
  const getAPI = useGetApi();
  return useCallback(
    async (promptId, requestBody) =>
      (await getAPI()).prompts.updatePrompt({ promptId, requestBody }),
    [getAPI]
  );
}
